import { useEffect } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import getChartColorsArray from "../Common/DynamicChartsColor";

const useChartColors = (chartId: string) => {
  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout: any) => ({
      layoutThemeType: layout.layoutThemeType,
      layoutThemeColorType: layout.layoutThemeColorType,
    })
  );
  // Inside your component
  const { layoutThemeType, layoutThemeColorType } = useSelector(
    selectLayoutProperties
  );

  useEffect(() => {
    getChartColorsArray(chartId);
  }, [chartId, layoutThemeType, layoutThemeColorType]);

  return [
    "#F4784A",
    "#F5921B",
    "#FFCC17",
    "#63BDBD",
    "#87BB62",
    "#4394E5",
    "#876FD4",
    "#E0E0E0",
    "#FF6F61",
    "#F6C90E",
    "#00B19A",
    "#3F51B5",
    "#9C27B0",
    "#29B6F6",
  ];

  // return [
  //   "#088F7D",
  //   "#f4a261",
  //   "#FF6F61",
  //   "#F6C90E",
  //   "#00B19A",
  //   "#3F51B5",
  //   "#9C27B0",
  //   "#29B6F6",
  // ];
};

export default useChartColors;
